import Container from '@/components/container/Container';
import Spacing from '@/components/container/Spacing';
import { TextBodyMedium, TextHeadlineLarge } from '@/components/text/Texts';
import { Accordion, AccordionTab } from 'primereact/accordion';
import styles from '../../onboarding.module.css';
import { ProgramSuggestionCardAccordionHeader } from '../AccordionHeader';
import SuggestedProgramContent from '../accordion-content/SuggestedProgramContent';
import { OnBoardingStateProgramProps } from '../ChooseProgramWizard';
import { BackButton } from '@/components/buttons/Buttons';

const RideProgramSuggestionsForm = (props: OnBoardingStateProgramProps) => {
	return (
		<Container>
			<div className="w-[1020px] max-w-full tablet:w-full">
				<TextHeadlineLarge
					text="Based on your responses, we've identified the following programs that may be a good fit for you."
					className="text-neutral17"
				/>
				<Spacing height="h-2" />
				<TextBodyMedium
					text="Select your first program to continue. You can add more programs later on."
					className="text-neutral17"
				/>
				<Spacing height="h-[40px]" />
				<Accordion
					activeIndex={0}
					className={styles.programSuggestionsAccordion}
					pt={{
						accordiontab: {
							root: () => ({
								className: styles.programSuggestionsRoot,
							}),
							header: () => ({
								className: styles.programSuggestionsHeader,
							}),
							headerAction: () => ({
								className: styles.headerAction,
							}),
							headerIcon: () => ({
								className: styles.icon,
							}),
							content: () => ({
								className: styles.programSuggestionsContent,
							}),
						},
					}}
				>
					<AccordionTab header={<ProgramSuggestionCardAccordionHeader />}>
						<SuggestedProgramContent
							onboardingProgram={props.onboardingProgram}
							isLoading={props.isLoading}
							onSubmit={props.onSubmit} />
					</AccordionTab>
				</Accordion>
				<Spacing height="h-[40px]" />
				<Container className="flex justify-between">
					{props.onBack ? (
						<BackButton
							withIcon={true}
							onClick={props.onBack}
							id="choose-program-back"
						/>
					) : (
						''
					)}
				</Container>
			</div>
		</Container>
	);
};

export default RideProgramSuggestionsForm;
